app.service('crmUploadsService', function ($http) {

  this.getUploadsByUser = function (obj) {
    return $http.post('/crmUploads/getUploadsByUser', obj)
      .then(function (response) {
        return response
      })
  }

  this.uploadFiles = function (formData) {
    return $http.post('/crmUploads/uploadFiles', formData, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined }
    }).then(function (response) {
      return response
    })
  }

  this.updateUploadComment = function (obj) {
    return $http.post('/crmUploads/updateUploadComment', obj)
      .then(function (response) {
        return response
      })
  }

  this.deleteUpload = function (obj) {
    return $http.post('/crmUploads/deleteUpload', obj)
      .then(function (response) {
        return response
      })
  }

})